import { render } from "./FormEditItem.vue?vue&type=template&id=09139bff"
import script from "./FormEditItem.vue?vue&type=script&lang=js"
export * from "./FormEditItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__